// noinspection DuplicatedCode

import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Dropzone from 'components/Dropzone/Dropzone';
import { Input, TextArea } from 'components/Forms';
import Alert from 'components/Alert/Alert';

const propTypes = {
  onCancel: PropTypes.func,
  onSubmitFiles: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  fileItem: PropTypes.object,
};
const defaultProps = {
  onCancel: () => null,
  onSubmitFiles: () => null,
  fileItem: {
    id: '',
    displayOrder: '',
    title: '',
    file: null,
    mediaPath: '',
  },
};

export default function FileManagerForm(props) {
  const { onCancel, onSubmitFiles, fileItem } = props;
  const [noFileSelected, setNoFileSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { control, setValue, handleSubmit } = useForm({
    defaultValues: fileItem,
  });
  const acceptedTypes = [
    'image/jpeg',
    'image/gif',
    'image/png',
    'text/plain',
    'application/pdf',
    'application/msword',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ];
  const onDropZoneUpload = (file) => {
    // setNoFileSelected(false);
    setValue('file', file);
  };
  const uploadFile = (formData) => {
    if (formData.id.length === 0) {
      setNoFileSelected(false);
      if (!Array.isArray(formData.file)) {
        setNoFileSelected(true);
        return;
      }
    }
    setIsLoading(true);
    onSubmitFiles(formData);
    setTimeout(() => {
      onCancel();
    }, 500);
  };
  useEffect(() => {
    if (fileItem) {
      if (fileItem.mediaPath) {
        setValue('mediaPath', fileItem.mediaPath);
      }
    }
    document.getElementById('displayOrder').setAttribute('min', 1);
  }, [fileItem]);

  return (
    <div className="add-file shadow-lg" data-testid="Wrapper-fileManagerForm">
      <Form onSubmit={handleSubmit(uploadFile)}>
        <div className="d-flex mb-2">
          <div className="d-block pe-2 pe-xl-2 pe-lg-2 pe-md-2 pe-sm-0">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="displayOrder" className="d-block">
              <strong>Display Order</strong>
            </label>
            <div className="d-block" style={{ width: '150px' }}>
              <Input
                type="number"
                control={control}
                disabled={isLoading}
                name="displayOrder"
                placeholder="Order"
                min="1"
              />
            </div>
          </div>
          <div className="d-block flex-grow-1">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="title" className="d-block">
              <strong>File Title</strong>
            </label>
            <Input
              control={control}
              disabled={isLoading}
              name="title"
              placeholder="Title"
              rules={{ required: true }}
            />
          </div>
        </div>
        <div className="d-block mb-3">
          <Dropzone
            onUpload={onDropZoneUpload}
            disabled={isLoading}
            value={fileItem?.mediaPath}
            className={classnames({ 'border-danger': noFileSelected })}
            accept={acceptedTypes.join(',')}
          />
          {noFileSelected && (
            <Alert
              variant="danger"
              className="p-2 mt-2"
              data-testid="Alert-noFile"
            >
              No file is selected.
            </Alert>
          )}
        </div>
        <div className="d-block mb-2">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="description" className="d-block">
            File Description
          </label>
          <TextArea
            control={control}
            name="description"
            placeholder="Description"
            rules={{ required: true }}
            disabled={isLoading}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Button
            variant="primary"
            disabled={isLoading}
            size="sm"
            className="btn-pmi"
            type="submit"
          >
            {isLoading ? 'Uploading..' : 'Upload'}
          </Button>
          <Button
            variant="link"
            disabled={isLoading}
            size="sm"
            type="button"
            onClick={onCancel}
            className="ms-3 mt-2"
          >
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}

FileManagerForm.propTypes = propTypes;
FileManagerForm.defaultProps = defaultProps;
